module.exports = __webpack_public_path__ + "static/img/katun02.e4a0fa1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/katun02.jpg
// module id = EhZK
// module chunks = 0